import React, { useState } from 'react';
import { Button, message } from 'antd';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import SeatingArrangementsModal from './SeatingArrangementsModal/SeatingArrangementsModal';
import './ticketOptions.less';
import { Event, EventTicket, EventTicketDeliveryMethod } from '../../sportsAndEventsInterface';
import TicketOptions from './TicketOptions';
import NoTicketsFallback from './NoTicketsFallback';

interface TicketOptionsProps {
  event: any;
  tickets: EventTicket[];
  isPackageView?: boolean;
  isDynamicPackage?: boolean;
  isPreviewMode?: boolean;
  handleSelectTicket?: ({
    ticket,
    quantity,
    deliveryMethod,
  }: {
    ticket: any;
    quantity: number;
    deliveryMethod: any;
  }) => void;
  handleRemoveTicket?: (ticketId: number) => void;
  selectedTicket?: {
    eventInfo: Event;
    ticket: EventTicket;
    quantity: number;
    deliveryMethod: EventTicketDeliveryMethod;
  };
  selectedTickets?: {
    eventInfo: Event;
    ticket: EventTicket;
    quantity: number;
    deliveryMethod: EventTicketDeliveryMethod;
  }[];
  initialQuantity?: number;
  scrollable?: boolean;
  onQuantityChange?: (quantity: number, ticketId?: number) => void;
  onDeliveryMethodChange?: (deliveryMethod: any, ticketId?: number) => void;
}

const TicketOptionsContainer: React.FC<TicketOptionsProps> = ({
  event,
  tickets,
  isPackageView = false,
  isDynamicPackage = false,
  isPreviewMode = false,
  selectedTicket,
  selectedTickets,
  initialQuantity,
  handleSelectTicket,
  handleRemoveTicket,
  scrollable = false,
  onQuantityChange,
  onDeliveryMethodChange,
}) => {
  const { sportsAndEvents: t_sportsAndEvents, cart: t_cart } = useSelector(
    (data: RootState) => data.config.translations
  );
  const [seatingModalOpen, setSeatingModalOpen] = useState(false);

  // Use selectedTickets if provided, otherwise fall back to single ticket
  const effectiveSelectedTickets = selectedTickets || (selectedTicket ? [selectedTicket] : []);

  return (
    <div className="ticket-options-container">
      {event?.venue?.mapUrl && (
        <div className="venue-map-image">
          <img src={event.venue.mapUrl} alt={event.venue.name || 'Venue Map'} />
          <Button
            type="link"
            icon={<AiOutlineInfoCircle />}
            onClick={() => setSeatingModalOpen(true)}
            className="seating-info-button btn-style-5"
          >
            {t_sportsAndEvents?.whereWillISit}
          </Button>
        </div>
      )}

      {tickets.length > 0 && (
        <TicketOptions
          event={event?.event ?? event}
          selectedTickets={effectiveSelectedTickets}
          tickets={tickets}
          isPackageView={isPackageView}
          isDynamicPackage={isDynamicPackage}
          isPreviewMode={isPreviewMode}
          handleSelectTicket={handleSelectTicket}
          handleRemoveTicket={handleRemoveTicket}
          initialQuantity={initialQuantity}
          scrollable={scrollable}
          onQuantityChange={onQuantityChange}
          onDeliveryMethodChange={onDeliveryMethodChange}
        />
      )}

      {/* {!isPreviewMode && tickets.length === 0 && event && (
        <NoTicketsFallback data={event} />
      )} */}

      <SeatingArrangementsModal
        open={seatingModalOpen}
        onClose={() => setSeatingModalOpen(false)}
      />
    </div>
  );
};

export default TicketOptionsContainer;
